import { Link } from "react-router-dom";
import ProjectCard from "./ProjectCard";
import projects from "../data/projects";
import joshpic from '../images/icons/josh_pic3.png'

const HomeMain = () => {

    return (
    <>
        <section className="hero">
            <div className="hero-text">
                <p className="status"><span className="status-dot"></span>Open to part-time work</p>
                <p className="eyebrow">Kia ora, my name is</p>
                <h1 className="hero-title">Joshua Simon</h1>
                <p className="hero-intro">
                    I'm a Wellington-based developer focused on mobile apps and front-end, with a background
                    in biochemistry and jazz. I like building things people actually use - especially for
                    Wellington's creative scene - and I'm currently open to part-time work in tech.
                </p>
                <div className="hero-actions">
                    <Link to = '/projects' className="button button-primary">View my work</Link>
                    <Link to = '/contact' className="button">Get in touch</Link>
                </div>
            </div>
            <img className="hero-photo" src = {joshpic} alt = 'Josh playing tenor saxophone on stage'/>
        </section>

        <section className="section">
            <div className="section-header">
                <h2 className="section-title">Recent work</h2>
                <Link to = '/projects' className="text-link">All projects →</Link>
            </div>
            <div className="project-grid">
                {projects.slice(0, 3).map(project => <ProjectCard project = {project} key = {project.id}/>)}
            </div>
        </section>
    </>
    );
}

export default HomeMain;
